import { PageResponseVm } from 'api/core/page-response.vm';
import { IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { ServerVm } from './server.vm';

export class GetServersVm extends PageResponseVm<ServerVm, string> {
  @IsString()
  nextOffset: string;

  @Type(() => ServerVm)
  @ValidateNested({ each: true })
  objects: ServerVm[];
}
